import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Input } from 'antd';
import { usePrevious } from '@hooks';
import React, { useEffect, useState } from 'react';

export interface UserTableSearchProps {
	onSearch: (value: string) => void;
	value?: string;
}

export const UserTableSearch: React.FC<UserTableSearchProps> = ({ onSearch, value = '' }) => {
	const [ searchValue, setSearchValue ] = useState(value);
	const previousValue = usePrevious(value);

	useEffect(() => {
		if (value !== previousValue && value !== searchValue) {
			setSearchValue(value);
			onSearch(value);
		}
	}, [ onSearch, previousValue, searchValue, value ]);

	return (
		<Input.Search
			allowClear
			className='user-email-filter'
			enterButton
			onChange={ (e) => setSearchValue(e.target.value) }
			onSearch={ onSearch }
			placeholder={ ADMIN_DASHBOARD_COPY.SEARCH_USERS_PLACEHOLDER }
			value={ searchValue } />
	);
};
